import Search from 'applications/sports/components/search/index.js';
import MojitoCore from 'mojito/core';
import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';

const { SettingsMenuPopup } = MojitoModules;
const { FlexPane } = MojitoPresentation.Components;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class MainNavigationBarAvantgarde extends UIViewImplementation {
    render() {
        return (
            <FlexPane config={this.config.container} class="ta-MainNavigationBarAvantgarde">
                <FlexPane config={this.config.innerContainer} class="ta-innerContainer">
                    <Search config={this.config.searchControllerView} />
                    <FlexPane
                        id={this.config.middleSlotId}
                        config={this.config.middleSlot}
                        class="ta-middleSlot"
                    />
                    <SettingsMenuPopup config={this.config.settingsMenuPopup} />
                </FlexPane>
            </FlexPane>
        );
    }
}
